import axios from "axios";
import auth from "./auth";
import member from "./member";
import appointment from "./appointment";
import feedback from "./feedback";
import visit from "./visit/visit";
import firstVisitForm from "./firstVisitForm/firstVisitForm";
import pacsImage from "./pacsImage";
import notification from "./notification";
import vipReservation from "./vipReservation";
import surveyForm from "./surveyForm";
import progress from "./progress";
import operation from "./operation";

const axiosInstance = (() => {
  const endpoint =
    process.env.NODE_ENV === "development"
      ? "http://localhost:3000"
      : "https://api.musoon.clinic";

  const axiosInstanceTmp = axios.create({
    baseURL: endpoint,
    headers: {
      "Content-Type": "application/json"
    },
    timeout: 30000 // 30 秒
  });

  axiosInstanceTmp.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      if (error?.response) return Promise.reject(error.response.data);
      return Promise.reject(error);
    }
  );

  return axiosInstanceTmp;
})();

export default {
  auth: auth(axiosInstance),
  member: member(axiosInstance),
  appointment: appointment(axiosInstance),
  visit: visit(axiosInstance),
  feedback: feedback(axiosInstance),
  firstVisitForm: firstVisitForm(axiosInstance),
  pacsImage: pacsImage(axiosInstance),
  notification: notification(axiosInstance),
  vipReservation: vipReservation(axiosInstance),
  surveyForm: surveyForm(axiosInstance),
  progress: progress(axiosInstance),
  operation: operation(axiosInstance)
};
